<template>
  <div class="item">
    <div class="id">{{ restaurantDetails.id }}</div>
    <div class="name">{{ restaurantDetails.name }}</div>
    <div class="location">{{ restaurantDetails.location }}</div>
  </div>
</template>

<script>
export default {
  name: "RestaurantAdminView",
  props: ["restaurantDetails"],
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid #000;
  padding: 15px 5px;
  margin: 0 5px 5px 5px;

  @media (min-width: 800px) {
    flex-direction: row;
  }

  .id {
    display: flex;
    justify-content: center;
    flex-basis: 33%;
  }

  .name {
    display: flex;
    justify-content: center;
    flex-basis: 34%;
  }

  .location {
    display: flex;
    justify-content: center;
    flex-basis: 33%;
  }
}
</style>
